/* Reading an answer row's fields.
 *
 * Their own module rather than `module/answer/List.js` because `/task/:id`'s answers table
 * needs them too, and importing that page would drag `answers.scss` into the tasks bundle —
 * Parcel re-emits a stylesheet per entry that reaches it (see CLAUDE.md on `list-page.scss`).
 */

/**
 * The URL of one photo, whatever shape it arrives in.
 *
 * ⚠ Three shapes are real, and assuming one is why the thumbnails rendered broken:
 * - `AnswerListSerializer` flattens each photo to a plain URL **string**;
 * - `AnswerSerializer` (the detail, and the list until picsell-api ships) nests
 *   `AnswerPhotoSerializer` — an **object**;
 * - and an `AnswerPhoto` itself holds a photo in **either** `photo_url` (hosted elsewhere, what
 *   the mobile app usually writes) or `photo` (an uploaded file). Reading only `photo_url` shows
 *   nothing for every file-backed photo.
 */
export const photoUrl = photo => {
  if (!photo) return null;
  if (typeof photo === "string") return photo;
  return photo.photo_url || photo.photo || null;
};

/** Every photo on an answer: the `AnswerPhoto` rows, plus the legacy single `Answer.photo`. */
export const photosOf = row => [...(row?.photos || []).map(photoUrl), ...(row?.photo ? [photoUrl(row.photo)] : [])].filter(Boolean);

/* The row's point and merchandiser. The list serializer lifts both to the top level; the full
   `AnswerSerializer` (which is what this endpoint returns until picsell-api ships) carries them
   under `visit`, and an answer with no visit falls back to the task's point. */
export const pointOf = row => row?.point || row?.visit?.point || row?.task?.point || null;
export const merchandiserOf = row => row?.merchandiser || row?.visit?.user || null;
/** `locality_name` on the list serializer, a nested `locality` on the full one. */
export const localityOf = point => point?.locality_name || point?.locality?.name || null;
